import {
  Avatar,
  Box,
  Dialog,
  Modal,
  Paper,
  Stack,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import MedicationIcon from '@mui/icons-material/Medication'
import API from '../../../../services/API'
import { DataGrid } from '@mui/x-data-grid'
import columns from './columns'
import CustomDataGrid from '../../../../components/DataGrid/CustomDataGrid'
import { useNavigate } from 'react-router-dom'
import MFALogin from '../../../../helpers/auth/MFALogin'
import CorrectAdministrationModal from './CorrectAdministrationModal'
import VoidAdministrationModal from './VoidAdministrationModal'

const MedicineAdministrations = () => {
  const [administrations, setAdministrations] = useState([])
  const [mfaAuthenticated, setMFAAuthenticated] = useState(false)
  const [loading, setLoading] = useState(true)
  const [fetchError, setFetchError] = useState(false)
  const [totalNumber, setTotalNumber] = useState(0)
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50,
  })
  const [openMFA, setOpenMFA] = useState(false)
  const [selectedAdministration, setSelectedAdministration] = useState(null)
  const [correctingAdministration, setCorrectingAdministration] = useState(null)
  const [voidingAdministration, setVoidingAdministration] = useState(null)
  const navigate = useNavigate()

  const loadRecords = () => {
    setLoading(true)
    API.get(
      `/medicines-management/administrations?page=${
        paginationModel.page
      }&count=${paginationModel.pageSize}`,
    )

      .then((res) => {
        if (res.status === 200) {
          setAdministrations(res.data.logs)
          setMFAAuthenticated(res.data.mfaAuthenticated)
          setTotalNumber(res.data.totalCount)
        } else {
          setFetchError(true)
        }
      })
      .catch((e) => {
        console.error(e)
        setFetchError(true)
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    loadRecords()
  }, [paginationModel])

  return (
    <Stack gap={2}>
      <Typography variant="title2">Medicine Administration Records</Typography>
      <Paper>
        <CustomDataGrid
          rows={administrations}
          getRowId={(row) => row._id}
          columns={columns({
            mfaAuthenticated,
            navigate,
            setOpenMFA,
            onCorrect: setCorrectingAdministration,
            onVoid: setVoidingAdministration,
          })}
          autoHeight
          loading={loading}
          pageSizeOptions={[10, 25, 50]}
          pagination
          paginationMode="server"
          rowCount={totalNumber}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          disableRowSelectionOnClick
        />
      </Paper>
      <Modal open={openMFA} onClose={() => setOpenMFA(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <MFALogin
            onSuccess={() => {
              setOpenMFA(false)
              loadRecords()
            }}
          />
        </Box>
      </Modal>
      <CorrectAdministrationModal
        administration={correctingAdministration}
        onClose={() => setCorrectingAdministration(null)}
        onCorrected={loadRecords}
      />
      <VoidAdministrationModal
        administration={voidingAdministration}
        onClose={() => setVoidingAdministration(null)}
        onVoided={loadRecords}
      />
    </Stack>
  )
}

export default MedicineAdministrations
